import ga from './ga';
import pendo from './pendo';

const trackEvent = (category, action, label, value) => {
  ga.trackEvent(category, action, label, value);
}

const track = {
  init: () => {
    ga.init();
    pendo.init();
  },
  config: (config) => {
    ga.config(config);
    pendo.config(config);
  },
  pageView: (path) => {
    ga.pageView(path);
  },
  event: {
    dashboard: {
      recentResponses: {
        itemsPerPage: (numberOfItems) => trackEvent('Dashboard', 'Items Per Page', `Set Items Per Page to ${numberOfItems}`, numberOfItems)
      },
      message: {
        dismiss: () => trackEvent('Dashboard', 'Dismiss Message')
      }
    }
  },
};

export default track;



// WEBPACK FOOTER //
// src/tracking/track.js